module.exports = __webpack_public_path__ + "img/shizi.ea933b82.png";